export default {
  'operationLog.title': 'Operation Log',
  'operationLog.filter.timeRange': 'Operation Time',
  'operationLog.filter.loginName': 'Operator',
  'operationLog.filter.loginNamePlaceholder': 'Login name',
  'operationLog.filter.menuId': 'Menu',
  'operationLog.filter.menuIdPlaceholder': 'Search or select a menu',
  'operationLog.menuNone': 'NONE',
  'operationLog.filter.requestUrl': 'Request URL',
  'operationLog.filter.requestUrlPlaceholder': 'Fuzzy match, e.g. /user/mgmt',
  'operationLog.filter.requestMethod': 'Method',
  'operationLog.filter.rsCode': 'rsCode',
  'operationLog.filter.clientIp': 'Client IP',
  'operationLog.filter.serviceName': 'Service',
  'operationLog.filter.traceId': 'TraceId',
  'operationLog.filter.search': 'Search',
  'operationLog.filter.reset': 'Reset',
  'operationLog.col.operationTime': 'Operation Time',
  'operationLog.col.loginName': 'Operator',
  'operationLog.col.systemName': 'Name',
  'operationLog.superAdmin': 'Super Admin',
  'operationLog.col.menu': 'Menu',
  'operationLog.col.serviceName': 'Service',
  'operationLog.col.requestMethod': 'Method',
  'operationLog.col.requestUrl': 'Request URL',
  'operationLog.col.rsCode': 'rsCode',
  'operationLog.col.rsMessages': 'rsMessages',
  'operationLog.col.clientIp': 'Client IP',
  'operationLog.col.durationMs': 'Duration(ms)',
  'operationLog.col.traceId': 'TraceId',
  'operationLog.col.detail': 'Detail',
  'operationLog.detail.title': 'Operation Log Detail',
  'operationLog.detail.basic': 'Basic',
  'operationLog.detail.userAgent': 'User-Agent',
  'operationLog.detail.requestParams': 'Request Params',
  'operationLog.detail.responseSummary': 'Response Summary',
  'operationLog.detail.exceptionMsg': 'Exception',
  'operationLog.fetchError': 'Query failed, please retry',
};
